module.exports = __webpack_public_path__ + "static/img/zuhedatu.8c72bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/zuhedatu.png
// module id = x3yq
// module chunks = 31